import type { BreakdownAsset } from '@/modules/tools/bankruptcy/stores/types'
import { currencyFromCents } from '@/utils'
import { SourceTrigger } from './SourceTrigger'

export const AssetsTable = ({ assets }: { assets: BreakdownAsset[] }) => {
  if (assets.length === 0) {
    return (
      <p className="text-muted-foreground text-sm">
        No non-exempt assets contributed to the estate.
      </p>
    )
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b text-left text-muted-foreground text-xs">
            <th className="py-2 pr-3 font-medium">Asset</th>
            <th className="px-3 py-2 text-right font-medium">Value</th>
            <th className="px-3 py-2 text-right font-medium">Lien</th>
            <th className="px-3 py-2 text-right font-medium">Exemption</th>
            <th className="py-2 pl-3 text-right font-medium">
              Scheduled equity
            </th>
          </tr>
        </thead>
        <tbody>
          {assets.map((asset, index) => (
            <tr
              key={`${asset.line}-${index}`}
              className="border-b last:border-0"
            >
              <td className="py-2 pr-3">
                <span className="font-medium">
                  {asset.description || `Line ${asset.line}`}
                </span>
                {asset.description && (
                  <span className="ml-1.5 whitespace-nowrap text-muted-foreground text-xs">
                    Line {asset.line}
                  </span>
                )}
              </td>
              <td className="whitespace-nowrap px-3 py-2 text-right tabular-nums">
                <SourceTrigger
                  source={asset.source}
                  label={asset.description || `Line ${asset.line}`}
                  className="justify-end"
                >
                  {currencyFromCents(asset.valueCents)}
                </SourceTrigger>
              </td>
              <td className="whitespace-nowrap px-3 py-2 text-right text-muted-foreground tabular-nums">
                {asset.lienCents > 0
                  ? `−${currencyFromCents(asset.lienCents)}`
                  : '—'}
              </td>
              <td className="whitespace-nowrap px-3 py-2 text-right text-muted-foreground tabular-nums">
                {asset.exemptionCents > 0
                  ? `−${currencyFromCents(asset.exemptionCents)}`
                  : '—'}
              </td>
              <td className="whitespace-nowrap py-2 pl-3 text-right font-medium tabular-nums">
                {currencyFromCents(asset.equityCents)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
